import { render, staticRenderFns } from "./CertificateExpirationAlert.vue?vue&type=template&id=4778c980"
import script from "./CertificateExpirationAlert.vue?vue&type=script&lang=js"
export * from "./CertificateExpirationAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports